import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { CompanyService } from 'src/app/app/company/company.service';
import { PaginationClientSideOptions } from 'src/app/app/_component/pagination-client-side/pagination-client-side-options';
import { PaginationColumn } from 'src/app/app/_component/pagination-client-side/pagination-column.class';
import { GetBookingByUserModel } from 'src/app/_models/booking-request.model';
import { BookingModel } from 'src/app/_models/booking.model';
import { SpaceAssignmentModel } from 'src/app/_models/space-assignment.model';
import {
  GetAssignmentsModel,
  GetSpacesModel,
} from 'src/app/_models/space-requests.model';
import { SpaceModel } from 'src/app/_models/space.model';
import { UserService } from 'src/app/_services';
import { BookingService } from 'src/app/_services/booking.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { SpaceService } from 'src/app/_services/space.service';
import { SpaceType } from 'src/app/_types/space-type';
import { SpaceBookingViewComponent } from '../space-booking-view/space-booking-view.component';
import { SpaceFilter } from '../space-filter/space-filter.model';
import { SpaceFilterService } from '../space-filter/space-filter.service';
import { SpaceViewComponent } from '../space-view/space-view.component';
import { UserAssignmentViewComponent } from '../user-assignment-view/user-assignment-view.component';
import { DateStiPipe } from './../../../../_pipes/date-sti.pipe';

@Component({
  selector: 'app-space-reservations',
  templateUrl: './space-reservations.component.html',
  styleUrls: ['./space-reservations.component.scss'],
})
export class SpaceReservationsComponent implements OnInit, OnDestroy {
  constructor(
    public translateService: TranslateService,
    public spaceService: SpaceService,
    public bookingService: BookingService,
    private userServ: UserService,
    private companyServ: CompanyService,
    public p: ThisPlatform,
    public spaceFilterService: SpaceFilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  componentRefUserAssignment: any = UserAssignmentViewComponent;
  componentRef: any = SpaceBookingViewComponent;
  componentRefParking: any = SpaceViewComponent;
  rowsLoaderBooking: RowsLoaderService;
  rowsLoader: RowsLoaderService;
  rowsLoaderParkingPlace: RowsLoaderService;
  today = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
  showLoaderAssignments: boolean;
  hideEmptyAssignments: boolean = false;
  hideEmptyBookings: boolean = false;

  addReservationRole: string;

  showLoaderReservations: boolean;
  alreadyTriggered: boolean = false;
  filterDetails: SpaceFilter = new SpaceFilter();

  actualSubscription: Subscription;
  activatedRouteSubscription: Subscription;
  changeSegmentSubscription: Subscription;

  showParkingList: boolean = false;

  filterDetailsSubject: Subject<SpaceFilter> = new Subject<SpaceFilter>();

  eventsSubject: Subject<void> = new Subject<void>();

  reservationsArray: BookingModel[] = [];
  assignmentsArray: SpaceAssignmentModel[] = [];
  searchbarValue = '';

  datePipe = new DateStiPipe(this.userServ);

  @Input()
  showAllReservations: boolean = false; // warunek na podstawie którego pokazywane są wszystkie rezerwacje.

  @Input()
  spaceType: SpaceType;

  @Output()
  segmentName: EventEmitter<any> = new EventEmitter<any>();

  popoverLegend = [
    'SPACE.LEGEND_HEADER',
    [
      {
        color: '#d60d8c',
        label: 'SPACE.LEGEND_RESERVATION',
      },
      {
        color: '#cacfdd',
        label: 'SPACE.LEGEND_USER_ASSIGNMENT',
      },
      {
        color: '#262e41',
        label: 'SPACE.LEGEND_COMPANY_ASSIGNMENT',
      },
    ],
  ];

  optionsMyAssignments: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    mobileViewBreakPoint: 1450,
    subheaderCssClass: 'parking-view__mobile-container',
    noResultsText: 'SPACE.PARKING.NO_ASSIGNED_PARKING_SPACE',
    styleClasses: ['parking-space-list__mobile-container', 'content-table'],
    headerStickyPosition: 131,
    mobileFilterButton: true,
    overrideCountTranslation: "SPACE.ASSIGNMENTS_"
  };

  optionsMyReservations: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    groupDateKey: 'startTime',
    noProblemDateKeys: ['startDate', 'endDate'],
    styleClasses: [
      'parking-reservations__mobile-fab-button-padding',
      'content-table',
      'parking-space-list__mobile-container',
    ],
    mobileViewBreakPoint: 1450,
    noResultsText: 'SPACE.NO_RESERVATIONS',
    headerStickyPosition: 131,
    gridColumnsCount: 15,
    mobileFilterButton: true,
    overrideCountTranslation: "SPACE.RESERVATIONS_"
  };

  optionsParkingPlace: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    styleClasses: ['parking-space-list__mobile-container', 'content-table'],
    customData: 'show-booking-chart',
    headerStickyPosition: 131,
  };

  columnsDefinitionMyReservations: PaginationColumn[] = [
    {
      name: 'picture',
      displayName: 'SPACE.VIEW',
      size: 1,
      sortable: false,
    },
    {
      name: 'building',
      displayName: 'SPACE.BUILDING',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.bookingSpaces[0].space.floor.building.name;
      },
    },
    {
      name: 'level',
      displayName: 'SPACE.LEVEL',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.bookingSpaces[0].space.floor.name;
      },
    },
    {
      name: 'place',
      displayName: 'SPACE.PLACE',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.bookingSpaces[0].space.name;
      },
    },
    {
      name: 'startDate',
      displayName: 'SPACE.RESERVATION_START',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.startTime;
      },
    },
    {
      name: 'endDate',
      displayName: 'SPACE.RESERVATION_END',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.endTime;
      },
    },
    {
      name: 'number',
      displayName: 'SPACE.PARKING.PLATE_NUMBER',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.bookingSpaces[0].number
          ? row.bookingSpaces[0].number
          : row.userOwner.carPlate;
      },
    },
    {
      name: 'name',
      displayName: 'SPACE.ASSIGNED_PERSON',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.userOwner.firstName + row.userOwner.lastName;
      },
    },
    {
      name: 'status',
      displayName: 'MENU.STATUS',
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.status
      },
    },
  ];

  columnsDefinitionMyAssignments: PaginationColumn[] = [
    {
      name: 'picture',
      displayName: 'SPACE.VIEW',
      size: 1,
      sortable: false,
    },
    {
      name: 'building',
      displayName: 'SPACE.BUILDING',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.space.floor.building.name;
      },
    },
    {
      name: 'level',
      displayName: 'SPACE.LEVEL',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.space.floor.name;
      },
    },
    {
      name: 'place',
      displayName: 'SPACE.PLACE',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.space.floor.name;
      },
    },
    {
      name: 'startDate',
      displayName: 'SPACE.RESERVATION_START',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.dateFrom;
      },
    },
    {
      name: 'endDate',
      displayName: 'SPACE.RESERVATION_END',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.dateTo;
      },
    },
    {
      name: 'number',
      displayName: 'SPACE.PARKING.PLATE_NUMBER',
      size: 4,
      sortable: true,
      colValue: (row) => {
        return row.number;
      },
    },
  ];

  columnsDefinitionParkingPlace: PaginationColumn[] = [
    {
      name: 'picture',
      displayName: 'SPACE.VIEW',
      size: 1,
      sizeLg: 2,
      sizeXl: 1,
      sortable: false,
    },
    {
      name: 'building',
      displayName: 'SPACE.BUILDING',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.floor.building.name;
      },
    },
    {
      name: 'floor',
      displayName: 'SPACE.LEVEL',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.floor.name;
      },
    },
    {
      name: 'name',
      displayName: 'SPACE.PLACE',
      size: 2,
      sortable: true,
    },
    {
      name: 'status',
      displayName: 'SPACE.RESERVATIONS',
      size: 5,
      sizeLg: 4,
      sizeXl: 5,
      info: this.popoverLegend,
      sortable: false,
    },
  ];

  async ngOnInit() {
    this.optionsMyAssignments.spaceType = this.spaceType;
    this.optionsMyReservations.spaceType = this.spaceType;
    this.optionsParkingPlace.spaceType = this.spaceType;

    switch (this.spaceType) {
      case SpaceType.Parking:
        this.addReservationRole = 'parking.my-reservations.add';
        this.optionsMyAssignments.subheaderText = this.translateService.instant(
          'SPACE.PARKING.ASSIGNED_PARKING_SPACE'
        );
        break;
      case SpaceType.Desk:
        this.optionsMyAssignments.subheaderText = this.translateService.instant(
          'SPACE.DESK.ASSIGNED_DESK'
        );
        this.addReservationRole = 'desk.my-reservations.add';
        this.columnsDefinitionMyReservations[6].displayName = '';
        this.columnsDefinitionMyAssignments[6].displayName = '';
        this.columnsDefinitionMyReservations[6].sortable = false;
        this.columnsDefinitionMyAssignments[6].sortable = false;
        break;
      case SpaceType.Room:
        break;
    }

    await this.companyServ.loadCompaniesSync();

    this.activatedRouteSubscription = this.activatedRoute.queryParamMap.subscribe(
      () => {
        if (this.alreadyTriggered == false) {
          this.loadReservations();
          this.loadAssignments();

          if (this.showAllReservations == false) {
            this.optionsMyReservations.customData = 'hideNameOnReservations';
          } else {
            this.optionsMyReservations.customData = null;
          }
          this.alreadyTriggered = true;
        }
      }
    );
    this.actualSubscription = this.spaceFilterService.filterDetailsSubject.subscribe(
      (filterDetails: SpaceFilter) => {
        this.filterDetails = filterDetails;

        if (filterDetails.showSpacesWithCharts == true) {
          this.loadSpaces();
        } else {
          this.loadReservations();
          this.loadAssignments();
        }
      }
    );
    this.spaceService.spaceAssignmentChanged.subscribe(() => {
      this.loadAssignments();
      this.loadReservations();
    });
  }

  onReroute() {
    this.alreadyTriggered = false;
    switch (this.spaceType) {
      case SpaceType.Parking:
        this.router.navigate(['app/parking/add-reservation']);
        break;
      case SpaceType.Desk:
        this.router.navigate(['app/desk/add-reservation']);
        break;
      case SpaceType.Room:
        break;
    }
  }

  onToggleFilter() {
    this.eventsSubject.next();
  }

  onToggleReservationList() {
    this.filterDetails.showPastReservations = !this.filterDetails
      .showPastReservations;

    this.spaceFilterService.reloadFilter(this.filterDetails);
  }

  rowsLoaderBookingServiceReady(loader: RowsLoaderService) {
    this.rowsLoaderBooking = loader;
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  rowsLoaderParkingPlaceServiceReady(loader: RowsLoaderService) {
    this.rowsLoaderParkingPlace = loader;
  }

  updateAssignments(data) {
    if (data === 'assignments') {
      this.loadAssignments();
    } else if (data === 'reservations') {
      this.loadReservations();
      this.loadAssignments();
    }
  }

  loadAssignments() {
    this.spaceService.assignmentsCounter = null;
    this.spaceService.assignmentsloading = true;

    let requestDetails: GetAssignmentsModel = {
      spaceType: this.spaceType,
      idUser: this.userServ.userStorage.id,
      full: 'true',
      endTimeGreatherThan: !this.showAllReservations
        ? this.filterDetails.showPastReservations
          ? null
          : this.today
        : null,
      dateFromGreatherThan: this.showAllReservations
        ? new Date(this.filterDetails.dateStart).toISOString()
        : null,
      dateToLessThan: this.showAllReservations
        ? new Date(this.filterDetails.dateEnd).toISOString()
        : null,
      buildings:
        this.filterDetails.buildingListId.length > 0
          ? this.filterDetails.buildingListId.join(',')
          : null,
      floors:
        this.filterDetails.floorListId.length > 0
          ? this.filterDetails.floorListId.join(',')
          : null,
    };

    this.showLoaderAssignments = true;
    this.spaceService
      .getAssignments(requestDetails)
      .subscribe((spaceAssignments: SpaceAssignmentModel[]) => {
        this.showLoaderAssignments = false;
        this.spaceService.assignmentsloading = false;
        this.assignmentsArray = spaceAssignments;
        this.spaceService.assignementsCounterSubject.next(
          spaceAssignments.length
        );
        this.hideEmptyAssignments = spaceAssignments.length === 0;
        if (!this.hideEmptyAssignments) {
          this.searchInAssignments();
        }

        /** Fix filter button displaying for view with assignments and reservations */
        this.hideEmptyAssignments 
          ? this.optionsMyReservations.mobileFilterButton = true 
          : this.optionsMyReservations.mobileFilterButton = false;
      });
  }

  updateReservations(data) {
    if (data === 'refresh') {
      this.loadReservations();
      this.loadAssignments();
    }
  }

  loadReservations() {
    this.bookingService.bookingsCounter = null;
    this.bookingService.bookingsLoading = true;

    let requestParams: GetBookingByUserModel = {
      spaceType: this.spaceType,
      idUserOwner: this.showAllReservations
        ? null
        : this.userServ.userStorage.id,
      order: 'DESC',
      startTimeGreatherThan: this.showAllReservations
        ? new Date(this.filterDetails.dateStart).toISOString()
        : null,
      endTimeLessThan: this.showAllReservations
        ? new Date(this.filterDetails.dateEnd).toISOString()
        : null,
      endTimeGreatherThan: this.showAllReservations
        ? null
        : this.filterDetails.showPastReservations
        ? null
        : this.today,
      buildings:
        this.filterDetails.buildingListId.length > 0
          ? this.filterDetails.buildingListId.join(',')
          : null,
      floors:
        this.filterDetails.floorListId.length > 0
          ? this.filterDetails.floorListId.join(',')
          : null,
    };

    this.showLoaderReservations = true;
    this.bookingService
      .getBookingByUser(requestParams)
      .subscribe((bookings: BookingModel[]) => {
        this.showLoaderReservations = false;
        this.hideEmptyBookings = bookings.length == 0;
        this.bookingService.bookingsLoading = false;

        this.bookingService.bookingsCounterSubject.next(bookings.length);
        setTimeout(() => {
          this.reservationsArray = bookings;
          this.searchInReservations();
        }, 0);
      });
  }

  loadSpaces() {
    this.spaceService.spacesCounter = null;

    let requestParams: GetSpacesModel = {
      type: this.spaceType,
      buildings: this.filterDetails.buildingList[0]
        ? this.filterDetails.buildingList[0].id.toString()
        : null,
      floors: this.filterDetails.floor
        ? this.filterDetails.floor.id.toString()
        : null,
      subType: this.filterDetails.subtype,
    };

    this.showLoaderReservations = true;
    this.spaceService
      .getSpaces(requestParams)
      .subscribe((res: SpaceModel[]) => {
        this.showLoaderReservations = false;
        this.spaceService.spaces = res;
        this.searchInSpaces();
      });
  }

  searchInReservations() {
    const tempArray: BookingModel[] = this.reservationsArray.filter(
      (s: BookingModel) =>
        [
          s.bookingSpaces[0].space.floor.building.name,
          s.bookingSpaces[0].space.floor.name,
          s.bookingSpaces[0].space.name,
          this.datePipe.transform(s.startTime),
          this.datePipe.transform(s.endTime),
          s.bookingSpaces[0].number
            ? s.bookingSpaces[0].number
            : s.userOwner.carPlate,
          s.userOwner.firstName,
          s.userOwner.lastName,
        ]
          .join(' ')
          .toUpperCase()
          .includes(this.searchbarValue.trim().toUpperCase())
    );
    this.bookingService.bookingsCounter = tempArray.length;
    this.bookingService.bookingsLoading = false;
    this.rowsLoaderBooking.init(tempArray);
  }

  searchInAssignments() {
    const tempArray: SpaceAssignmentModel[] = this.assignmentsArray.filter(
      (s: SpaceAssignmentModel) => {
        return [
          s.space.floor.building.name,
          s.space.floor.name,
          s.space.name,
          this.datePipe.transform(s.dateFrom),
          this.datePipe.transform(s.dateTo),
          s.number,
        ]
          .join(' ')
          .toUpperCase()
          .includes(this.searchbarValue.trim().toUpperCase());
      }
    );
    this.spaceService.assignmentsCounter = tempArray.length;
    setTimeout(() => {
      this.rowsLoader.init(tempArray);
    }, 0);
  }

  searchInSpaces() {
    const tempArray: SpaceModel[] = this.spaceService.spaces.filter(
      (s: SpaceModel) => {
        return [s.floor.building.name, s.floor.name, s.name]
          .join(' ')
          .toUpperCase()
          .includes(this.searchbarValue.trim().toUpperCase());
      }
    );
    this.spaceService.spacesCounter = tempArray.length;
    this.rowsLoaderParkingPlace.init(tempArray);
  }

  ngOnDestroy() {
    this.alreadyTriggered = false;
    this.actualSubscription.unsubscribe();
    this.activatedRouteSubscription.unsubscribe();
  }
}
